export default __webpack_public_path__ + "static/media/operate.1fe39fef.svg";